/**
 * AC Collection — artist. Closes the open filter and sort dropdowns when the shopper clicks outside them.
 * Filters and sort are plain links, so nothing else is needed. Loaded deferred by sections/ac-collection-artist.liquid.
 */
class AcCollectionArtist extends HTMLElement {
  connectedCallback() {
    this.onDocumentClick = (event) => {
      this.querySelectorAll('.acc-dd[open]').forEach((dropdown) => {
        if (!dropdown.contains(event.target)) dropdown.removeAttribute('open');
      });
    };
    document.addEventListener('click', this.onDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
  }
}

if (!customElements.get('ac-collection-artist')) {
  customElements.define('ac-collection-artist', AcCollectionArtist);
}
